<template>
    <div>
      <Head title="Admin" />
      <v-container class="grey lighten-5">
        <v-card>
          <v-card-title>
            Permissions
            <v-spacer></v-spacer>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              @input="getDataFromApi()"
              single-line
              hide-details
            ></v-text-field>
            <v-spacer></v-spacer>
            <v-select
              v-model="role"
              label="Role"
              :items="roles"
              prepend-icon="mdi-card-account-details"
              @change="getDataFromApi()"
              item-text="name"
              item-value="id"
              single-line
              hide-details
              clearable
            ></v-select>
           
            <v-spacer></v-spacer>
            <v-btn
            class="mx-2"
            fab
            dark
            color="primary"
            @click="addNew"
          >
            <v-icon dark>
              mdi-plus
            </v-icon>
          </v-btn>
          </v-card-title>
            <v-data-table
            :headers="headers"
            :items="permissions"
            :options.sync="options"
            :items-per-page="itemsPerPage"
            :server-items-length="total"
            :loading="loading"
            class="elevation-1"
          >
          <template v-slot:item.roles="{ item }">
                <td>
                    
                        {{ item.roles.map(u => u.name).join(', ') }}
                    
                </td>
            </template>
            </v-data-table>
        </v-card> 

        <v-dialog v-model="dialogAdd" max-width="500px"
        >
          <v-card>
            <v-card-title>
              <span class="text-h5">Add New Permission</span>
            </v-card-title>

            <v-card-text>
              <v-container>
                <v-row>
                    
                  <v-col
                    cols="12"
                    sm="12"
                    md="6"
                  >
                    <v-text-field
                      v-model="newpermission.name"
                      label="Name"
                    ></v-text-field>
                  </v-col>
                  
                  
                  
                </v-row>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="blue darken-1"
                text
                @click="closeAddDialog"
              >
                Cancel
              </v-btn>
              <v-btn
                color="blue darken-1"
                text
                @click="saveAddDialog"
              >
                Save
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="dialogDelete" max-width="500px">
          <v-card>
            <v-card-title class="text-h5">Are you sure you want to delete this item?</v-card-title>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="dialogDelete = !dialogDelete">Cancel</v-btn>
              <v-btn color="blue darken-1" text @click="deleteItemConfirm">OK</v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>
        
      </v-container>
    </div>
  </template>
  
  <script>
  import { Head } from '@inertiajs/inertia-vue'
  import Layout from '@/Shared/VuetifyAdminLayout'
  import axios from 'axios'
  

  export default {
    props: {
      roleList: Array,
      permissionList: Array
    },
    components: {
      Head,
    },
    layout: Layout,
    data() {
        return {
            role: '',
            roles: [],
            permissions: [],
            list: [],
            keyword: "",
            location: "",
            category: "",
            total: this.roleList ? this.roleList.length : 0,
            itemsPerPage: 20,
            loading: false,
            loadingAdd: false,
            options: {},
            search: "",
            headers: [
              { text: 'ID', value:'id'},
              { text: 'Name', value:'name'},
              { text: 'Roles', value:'roles',sortable:false}

            ],
            newpermission: {
              name:""
            },
            dialogAdd: false,
            dialogDelete: false
        }
    },
    watch: {
      options: {
        handler () {
          this.getDataFromApi()
        },
        deep: true,
      },
    },
    created() {
      this.roles = JSON.parse(JSON.stringify(this.roleList));
      this.permissions = JSON.parse(JSON.stringify(this.permissionList));
    },
    methods: {
      generatePassword() {
        this.newpermission.password= [...window.crypto.getRandomValues(new Uint32Array(passwordLength))]
                .map(x => passwordChars[x % passwordChars.length])
                .join('')
      },
      addNew(){
        Object.keys(this.newpermission).forEach(key => {
          this.newpermission[key] = "";
        });
        this.dialogAdd = true;
      },
      getDataFromApi () {
        this.loading = true
        console.log('getting request',this.options)
        var params = JSON.parse(JSON.stringify(this.options));
        params.filters = { search: this.search, role: this.role };

        axios.get("/admin/permissions/list",{ params: params }).then((response) => {
          this.permissions = response.data.list
          this.total= response.data.total;
          this.loading = false;
        });
      },
      deleteItemConfirm () {
        this.closeDelete()
      },

      closeAddDialog () {
        this.dialogAdd = false
      },

      closeDelete () {
        this.dialogDelete = false
        
      },

      saveAddDialog () {
        this.loadingAdd=true;
        console.log('adding permissions',this.newpermission)
        axios.post("/admin/permissions/add",this.newpermission).then((response) => {
          if (response.status == '200' && response.data == true)
          {
            this.dialogAdd = false;
            this.getDataFromApi();
          }
          else
            alert('Add failed');
          
            console.log('add response',response)
          this.loadingAdd = false;
        });
        //this.dialogAdd = false
      },
      
    },
  }
  </script>
  